<script setup lang="ts" generic="TData, TValue">
  import type { Column, Header, HeaderContext } from '@tanstack/vue-table'
  import {
    FlexRender,
    getCoreRowModel,
    getSortedRowModel,
    getPaginationRowModel,
    getFilteredRowModel,
    getExpandedRowModel,
    useVueTable,
    defaultColumnSizing
  } from '@tanstack/vue-table'
  import {
    MoveUp,
    MoveDown,
    ArrowUpDown,
    ArrowDownNarrowWide,
    ArrowUpNarrowWide,
    EyeOff,
    X,
    Filter,
    ListFilter
  } from 'lucide-vue-next'
  import { computed, watch, type StyleValue } from 'vue'
  import { cn } from '../../lib/utils'
  import GatButton from '../gat-button/gat-button.vue'
  import GatIcon from '../gat-icon/gat-icon.vue'
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
  } from '../ui/dropdown-menu'
  import type { GatColumnDef } from '.'

  export interface DataTableColumnHeaderProps<TData, TValue> {
    header: HeaderContext<TData, TValue>
    title?: string
  }

  const props = defineProps<DataTableColumnHeaderProps<TData, TValue>>()

  const column = computed(
    () => props.header.column.columnDef as GatColumnDef<TData, TValue>
  )

  defineOptions({
    name: 'DataTableColumnHeader',
    inheritAttrs: false
  })
  /* 
watch(
  () => props.header,
  (newVal) => {
    console.log(newVal)
  },
  {
    immediate: true
  }
) */
</script>

<template>
  <div :class="cn('flex items-center gap-2')">
    <div class="flex items-center gap-2">
      <!-- v-if="!header.column.getCanSort() && !header.column.getCanHide()" -->
      <div
        class="spx-3 flex items-center gap-1 py-2 text-left text-sm font-normal"
        v-if="column.title ?? title"
      >
        <span>
          {{ column.title ?? title }}
        </span>
        <button
          class="size-5 hover:cursor-pointer"
          @click="header.column.toggleSorting()"
        >
          <ArrowUpNarrowWide
            v-if="header.column.getIsSorted() === 'desc'"
            class="size-3.5"
          />
          <ArrowDownNarrowWide
            v-else-if="header.column.getIsSorted() === 'asc'"
            class="size-3.5"
          />
          <ArrowUpDown v-else class="size-3.5" />
        </button>
      </div>
      <!-- <DropdownMenu v-else>
        <DropdownMenuTrigger as-child>
          <button></button>
          <GatButton
            variant="ghost"
            size="sm"
            class="data-[state=open]:bg-accent -ml-3 h-8 text-sm font-normal"
            :class="[header.column.getIsSorted() ? 'text-primary' : '']"
          >
            <span class="text-secondary-foreground/80">{{ column.title ?? title }}</span>
            <ArrowDownNarrowWide v-if="header.column.getIsSorted() === 'desc'" class="size-3.5" />
            <ArrowUpNarrowWide v-else-if="header.column.getIsSorted() === 'asc'" class="size-3.5" />
            <div v-else-if="header.column.getCanSort()">
              <ArrowUpDown class="size-3.5" />
            </div>
          </GatButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem
            v-if="header.column.getIsSorted()"
            @click="header.column.clearSorting()"
          >
            <X class="text-soft/70 mr-2 size-3.5" />
            Clear Sorting
          </DropdownMenuItem>
          <DropdownMenuItem
            v-if="header.column.getCanSort()"
            @click="header.column.toggleSorting(false)"
          >
            <ArrowUpNarrowWide class="text-soft/70 mr-2 size-3.5" />
            Asc
          </DropdownMenuItem>
          <DropdownMenuItem
            v-if="header.column.getCanSort()"
            @click="header.column.toggleSorting(true)"
          >
            <ArrowDownNarrowWide class="text-soft/70 mr-2 size-3.5" />
            Desc
          </DropdownMenuItem>
          <slot name="addons"> </slot>
          <DropdownMenuSeparator v-if="header.column.getCanHide() && header.column.getCanSort()" />
          <DropdownMenuItem
            v-if="header.column.getCanHide()"
            @click="header.column.toggleVisibility(false)"
          >
            <EyeOff class="text-soft/70 mr-2 size-3.5" />
            Hide
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu> -->
    </div>
  </div>
</template>
